import { createRoot } from "react-dom/client";

import { WidgetApp } from "./widget/widget-app";
import { widgetCss } from "./widget/widget-css";
import { getWidgetScriptConfig } from "./widget/widget-config";

function boot() {
  // If the script is placed in <head>, `document.body` might not exist yet.
  // Wait for DOM readiness so we can safely append the host element.
  if (typeof document !== "undefined" && !document.body) {
    document.addEventListener("DOMContentLoaded", boot, { once: true });
    return;
  }

  const config = getWidgetScriptConfig();
  if (!config) return;

  const host = document.createElement("div");
  host.setAttribute("data-weyni-widget", "");

  // Keep the host element in the light DOM, but isolate all styles in Shadow DOM.
  (document.body ?? document.documentElement).appendChild(host);

  const shadow = host.attachShadow({ mode: "open" });

  const style = document.createElement("style");
  style.textContent = widgetCss;
  shadow.appendChild(style);

  const rootEl = document.createElement("div");
  rootEl.id = "weyni-widget-root";
  shadow.appendChild(rootEl);

  createRoot(rootEl).render(<WidgetApp {...config} />);
}

boot();
